import React, { useState, useEffect, useRef} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import useResponsiveFlags from "../hooks/useResponsiveFlags";

export function TermsofUse({ formData, updateFormData, errors }) {
  const handleChange = (e) => {
    const { checked } = e.target;
    updateFormData({ termsAccepted: checked });
  };

  return (
    <div style={{ padding: "2rem 0" }}>
      <p className="login text-center">Terms of Use</p>
      <p className="review-text">
        Please review and accept the licensing terms before using iSort &trade;
      </p>
      <div style={{ marginTop: "2rem", height: "250px", overflowY: "scroll" }}>
        <p>
          CiberMed Inc. (“CiberMed”) provides iSort&trade; website features and
          services (“Service”).
        </p>
        By using the Service, you agree to be bound by the terms of this
        Agreement. Please read it carefully.
        <br />
        <ul>
          <li>
            You agree not to use the Service for diagnosis, treatment, cure,
            prevention, or mitigation of disease or other conditions in man or
            other animals. You acknowledge that the Service and any information
            obtained therefrom is not intended to substitute for care by a
            licensed healthcare professional.
          </li>
        </ul>{" "}
        <p>
          <b>
            THE SERVICE IS OFFERED “AS IS”, AND, TO THE EXTENT PERMITTED BY LAW,
            CIBERMED MAKES NO REPRESENTATIONS AND EXTENDS NO WARRANTIES OF ANY
            KIND, EITHER EXPRESS OR IMPLIED. CIBERMED SHALL NOT BE LIABLE FOR
            ANY CLAIMS OR DAMAGES WITH RESPECT TO ANY LOSS OR OTHER CLAIM BY YOU
            OR ANY THIRD PARTY ON ACCOUNT OF, OR ARISING FROM THE USE OF THE
            SERVICE. YOU HEREBY AGREE TO DEFEND AND INDEMNIFY CIBERMED, ITS
            EMPLOYEES, OFFICERS, AGENTS, CONSULTANTS, REPRESENTATIVES, AND
            VOLUNTEERS (“CIBERMED INC. INDEMNITEES”) FROM ANY LOSS OR CLAIM
            ASSERTED AGAINST CIBERMED INDEMNITEES ARISING FROM YOUR USE OF THE
            SERVICE.
          </b>
        </p>
        <ul>
          <li>
            All rights not expressly granted to you in this Agreement are
            reserved and retained by CiberMed Inc. or its licensors or content
            providers. This Agreement provides no license under any patent.
          </li>
          <li>
            You agree that this Agreement and any dispute arising under it is
            governed by the laws of the State of California, United States of
            America, applicable to agreements negotiated, executed, and
            performed within California.
          </li>
        </ul>
        <p>
          Subject to your compliance with the terms and conditions set forth in
          this Agreement, CiberMed Inc. grants you a revocable, non-exclusive,
          non-transferable right to access and make use of the Service.
        </p>
        <h6>Disclaimer</h6>
        <p>
          iSort&trade; is for research use only, and shall not be used for
          diagnosis, treatment, cure, prevention, or mitigation of disease or
          other conditions in human or other animals.
        </p>
        <p>
          {" "}
          iSort&trade; is a research tool being supplied as is, without any
          accompanying services, support, or improvements from CiberMed, unless
          otherwise stated. CiberMed makes no representations and extends no
          warranties of any kind, neither express nor implied.
        </p>
        <h6> Intellectual Property Rights</h6>
        <p>
          The core technology of iSort&trade; is patented, and is fully and
          exclusively licensed from Stanford University to CiberMed.
        </p>
        <p>
          {" "}
          Unless otherwise indicated, this iSort&trade; website (“Site”) is our
          proprietary property and all source code, databases, functionality,
          software, website designs, audio, video, text, photographs, and
          graphics on the Site (collectively, the “Content”) and the trademarks,
          service marks, and logos contained therein (the “Marks”) are owned or
          controlled by us or licensed to us, and are protected by copyright and
          trademark laws and various other intellectual property rights and
          unfair competition laws of the United States, foreign jurisdictions,
          and international conventions. The Content and the Marks are provided
          on the Site “AS IS” for your information and personal use only. Except
          as expressly provided in these Terms of Use, no part of the website
          and no Content or Marks may be copied, reproduced, aggregated,
          republished, uploaded, posted, publicly displayed, encoded,
          translated, transmitted, distributed, sold, licensed, or otherwise
          exploited for any commercial purpose whatsoever, without our express
          prior written permission.
        </p>
        <p>
          {" "}
          Provided that you are eligible to use the Service, you are granted a
          limited license to access and use the Service and to download or print
          a copy of any portion of the Content to which you have properly gained
          access solely for your personal, non-commercial use. We reserve all
          rights not expressly granted to you in and to the Service, the Content
          and the Marks.
        </p>
      </div>
      <div className="form-check mt-4">
        <input
          className="form-check-input"
          type="checkbox"
          id="termsCheck"
          checked={formData.termsAccepted}
          onChange={handleChange}
        />
        <label htmlFor="termsCheck">
          I accept the terms of the license.
        </label>

        {errors.termsAccepted && (
          <p className="error-text">{errors.termsAccepted}</p>
        )}
      </div>
    </div>
  );
}

export function Personal({ formData, updateFormData, errors, requiresCaptcha = false, onEmailCaptchaChange, captchaRef}) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({
      personalInfo: {
        ...formData.personalInfo,
        [name]: value,
      },
    });
  };

  const handleEmailChange = (e) => {
    handleChange(e);
    if(requiresCaptcha && captchaRef.current){
      onEmailCaptchaChange?.("");
    }
  };
  const handleCaptchaChange = (token) => {
    onEmailCaptchaChange?.(token || "");
  };
  const handleCaptchaExpired = () => {
    onEmailCaptchaChange?.("");
  };

  return (
    <div style={{ padding: "4rem 0 2rem 0" }}>
      <form>
        <div className="form-group">
          <label htmlFor="firstName" className="form-label">
            First Name*
          </label>
          <input
            type="text"
            name="firstName"
            value={formData.personalInfo.firstName}
            onChange={handleChange}
            id="fname"
          />
          {errors.firstName && <p className="error-text">{errors.firstName}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="lastName" className="form-label">
            Last Name*
          </label>
          <input
            type="text"
            name="lastName"
            value={formData.personalInfo.lastName}
            onChange={handleChange}
            id="lname"
            required="required"
            pattern="[a-zA-z ]{2,}"
            maxLength="30"
          />
          {errors.lastName && <p className="error-text">{errors.lastName}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="email" className="form-label">
            Email*
          </label>
          <input
            type="email"
            name="email"
            id="email"
            value={formData.personalInfo.email}
            onChange={handleEmailChange}
            required="required"
          />
          {errors.email && <p className="error-text">{errors.email}</p>}

          <small className="review-text">
            Please use email of your organisation. Web mails or emails that does
            not identify organization (such as qq.com) are not accepted.
          </small>
          {requiresCaptcha && (
            <div className="recaptcha-wrapper mt-3">
              <small className="review-text d-block mb-2">
                Please verify you are not a robot to continue.
              </small>
              <ReCAPTCHA
                ref={captchaRef}
                sitekey={process.env.REACT_APP_SITE_KEY}
                onChange={handleCaptchaChange}
                onExpired={handleCaptchaExpired}
              />
              {errors.emailCaptcha && (
                <p className="error-text">{errors.emailCaptcha}</p>
              )}
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

export function Organization({ formData, updateFormData, errors }) {
  const { isMobile } = useResponsiveFlags();

  const [isEditable, setIsEditable] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (formData.organizationInfo.orgCode) {
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  }, [formData.organizationInfo.orgCode]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({
      organizationInfo: {
        ...formData.organizationInfo,
        [name]: value,
      },
    });
  };

  const handleOrgCodeChange = async (e) => {
    const { name, value } = e.target;
    updateFormData({
      organizationInfo: {
        ...formData.organizationInfo,
        [name]: value,
      },
    });

    if (name === "orgCode") {
      updateFormData({
        organizationInfo: {
          orgCode: value,
          address: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          orgId: "",
          orgName: "",
        },
      });
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  };

  return (
    <div style={{ padding: "2rem 0" }}>
      <form>
        <div className="form-group">
          <label className="form-label">
            <br />
            Organization Code
          </label>
          <input
            type="text"
            name="orgCode"
            id="orgcode"
            value={formData.organizationInfo.orgCode}
            onChange={handleOrgCodeChange}
          />
          {loading && (
            <small className="review-text">
              Fetching organization details...
            </small>
          )}
          <br />
          <small className="review-text">
            If your organization is already registered, your organization code
            can be found with the account details of already registered users.
          </small>
          {errors.orgCode && <p className="error-text">{errors.orgCode}</p>}
        </div>

        <div className="form-group">
          <label className="form-label">Organization Name*</label>
          <input
            type="text"
            name="orgName"
            id="orgname"
            value={formData.organizationInfo.orgName}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
          <small className="review-text">
            Your place of work, or corporation with which you are affiliated.
          </small>
          {errors.orgName && <p className="error-text">{errors.orgName}</p>}
        </div>

        <div className="form-group">
          <label className="form-label">Address*</label>
          <input
            type="text"
            name="address"
            id="address"
            value={formData.organizationInfo.address}
            onChange={handleChange}
            required="required"
            disabled={!isEditable}
          />
          {errors.address && <p className="error-text">{errors.address}</p>}
        </div>

        <div className="form-group">
          <label className="form-label">City*</label>
          <input
            type="text"
            name="city"
            id="city"
            value={formData.organizationInfo.city}
            onChange={handleChange}
            required="required"
            disabled={!isEditable}
          />
          {errors.city && <p className="error-text">{errors.city}</p>}
        </div>

        <div className="row form-group">
          <div className="col-12 col-md-6 mb-3">
            <label htmlFor="state" className="form-label">
              State or Province*
            </label>
            <input
              type="text"
              name="state"
              id="state"
              value={formData.organizationInfo.state}
              onChange={handleChange}
              required
              disabled={!isEditable}
            />
            {errors.state && (
              <div className="error-text">{errors.state}</div>
            )}
          </div>

          <div className="col-12 col-md-6 mb-3">
            <label htmlFor="zip" className="form-label">
              ZIP or Postal Code*
            </label>
            <input
              type="text"
              name="zip"
              id="zip"
              value={formData.organizationInfo.zip}
              onChange={handleChange}
              required
              disabled={!isEditable}
            />
            {errors.zip && <div className="error-text">{errors.zip}</div>}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Country*</label>
          <input
            type="text"
            name="country"
            id="country"
            value={formData.organizationInfo.country}
            onChange={handleChange}
            required="required"
            disabled={!isEditable}
          />
          {errors.country && <p className="error-text">{errors.country}</p>}
        </div>
      </form>
    </div>
  );
}

export function Password({ formData, updateFormData, errors, captchaRef }) {

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({
      passwordInfo: {
        ...formData.passwordInfo,
        [name]: value,
      },
    });
  };
  const handleCaptchaChange = (token) => {
    updateFormData({
      passwordInfo: {
        ...formData.passwordInfo,
        captcha: token,
      },
    });
  };

  // async function handleLogin(e) {
  //   const recaptchaValue = recaptcha.current.getValue();
  //   console.log(recaptchaValue);
  //   if (!recaptchaValue) {
  //     alert("Please verify the reCAPTCHA!");
  //     return;
  //   } else {
  //     const res = await fetch("http://localhost:8000/api/verify", {
  //       method: "POST",
  //       body: JSON.stringify({ captchaValue: recaptchaValue }),
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //     });

  //     const data = await res.json();
  //     console.log(data);
  //     if (data.success) {
  //       formData.passwordInfo.captcha = true;
  //     }
  //   }
  // }

  return (
    <div className="form-group" style={{ padding: "2rem 0" }}>
      <p>
        Password must:
        <ul style={{ padding: "0 0 0 15px", margin: "5px 0" }}>
          <li>Be at least 8 characters</li>
          <li>Include both uppercase and lowercase letters</li>
          <li>Include at least one special character (e.g., ! @ # $)</li>
        </ul>
      </p>

      <form>
        <div className="form-group">
          <label className="form-label">Password*</label>
          <input
            type="password"
            name="password"
            id="password"
            value={formData.passwordInfo.password}
            onChange={handleChange}
            required="required"
          />
          {errors.password && <p className="error-text">{errors.password}</p>}
        </div>

        <div className="form-group">
          <label className="form-label">Confirm Password*</label>
          <input
            type="password"
            name="password_confirmation"
            id="password_confirmation"
            value={formData.passwordInfo.password_confirmation}
            onChange={handleChange}
            required="required"
          />
          {errors.password_confirmation && (
            <p className="error-text">{errors.password_confirmation}</p>
          )}
        </div>
        <div className="recaptcha-wrapper">
          <ReCAPTCHA
            id="captcha"
            name="captcha"
            ref={captchaRef}
            sitekey={process.env.REACT_APP_SITE_KEY}
            onChange={(token)=>{handleCaptchaChange(token)}}
          />
        </div>
        {errors.captcha && <p className="error-text">{errors.captcha}</p>}
      </form>
    </div>
  );
}
